import { c as _c } from "react/compiler-runtime";
import { Banner } from '@onefootprint/ui';
import type { ReactNode } from 'react';
type NotEnabledShellProps = {
  message: string;
  cta: {
    label: string;
    href: string;
  };
  children: ReactNode;
};
const NotEnabledShell = t0 => {
  const $ = _c(11);
  const {
    message,
    cta,
    children
  } = t0;
  let t1;
  if ($[0] !== cta.href || $[1] !== cta.label) {
    t1 = <a href={cta.href}>{cta.label}</a>;
    $[0] = cta.href;
    $[1] = cta.label;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== message || $[4] !== t1) {
    t2 = <Banner variant="warning" className="border-b border-tertiary">{message}{t1}</Banner>;
    $[3] = message;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== children) {
    t3 = <div inert={true} className="relative flex-1 overflow-auto">{children}</div>;
    $[6] = children;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="absolute inset-0 flex flex-col bg-primary">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default NotEnabledShell;